import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Card, Typography } from "@mui/material";
import MemberPicker from "./Dashboard/MemberPicker";
import NewWorkOrderForm from "./Dashboard/NewWorkOrderForm";

const NewWorkOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMember, setSelectedMember] = useState(location.state?.member || null);

  return (
    <Box sx={{ p: 3, maxWidth: 640 }}>
      <Card sx={{ borderRadius: "18px", p: 3, border: "1px solid rgba(47,99,173,0.08)", boxShadow: "0 8px 24px rgba(0,0,0,0.06)" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142", mb: 0.5 }}>
          Create New Green Sheet
        </Typography>
        <Typography variant="body2" sx={{ color: "#6b778c", mb: 2.5 }}>
          Select a property and describe the work needed.
        </Typography>

        <Box sx={{ mb: 2 }}>
          <MemberPicker
            selectedMember={selectedMember}
            onSelect={setSelectedMember}
            onClear={() => setSelectedMember(null)}
          />
        </Box>

        <NewWorkOrderForm
          propertyId={selectedMember?.ClubMemberCode}
          onSuccess={() => navigate("/home/workorders", { state: { reload: true } })}
          onCancel={() => navigate(-1)}
        />
      </Card>
    </Box>
  );
};

export default NewWorkOrder;
